import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';

const NotFound = () => {
  return (
    <section
      aria-labelledby="not-found-title"
      className="mx-auto w-full max-w-3xl px-6 pb-32 pt-40 text-center"
    >
      <SEO
        title="Page Not Found"
        description="The requested Broadway Muses page could not be found."
        path="/404"
        indexable={false}
      />

      <header className="border-b-8 border-black pb-8">
        <h1
          id="not-found-title"
          className="break-words font-serif text-5xl font-black uppercase italic md:text-8xl"
        >
          Page Not Found
        </h1>
      </header>

      <p className="mt-10 font-mono text-sm uppercase leading-loose">
        The page you requested is not available.
      </p>

      <Link
        to="/"
        className="mt-10 inline-block border-2 border-black bg-black px-8 py-4 font-mono text-xs font-black uppercase tracking-[0.2em] text-white transition-colors hover:bg-white hover:text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-black"
      >
        Return to Broadway Muses
      </Link>
    </section>
  );
};

export default NotFound;